/**
 *
 * @param startDate - The start date of the action plan.
 * @param endDate - The end date of the action plan.
 * @param updatedAt - The last updated date of the action plan.
 * @returns The duration progress of the action plan.
 */

export const calculateDurationProgress = (
  startDate: Date,
  endDate: Date,
  updatedAt: Date | null
) => {
  if (!updatedAt) return 0;
  const totalDuration = endDate.getTime() - startDate.getTime();
  const elapsed = updatedAt.getTime() - startDate.getTime();

  if (totalDuration <= 0) return 0;

  const progress = elapsed / totalDuration;
  return Math.max(0, Math.min(1, progress)) * 100; // Clamp between 0 and 1 and multiply by 100 to get percentage
};
